import { render, staticRenderFns } from "./Tabbar.vue?vue&type=template&id=1d89b952&scoped=true&"
import script from "./Tabbar.vue?vue&type=script&setup=true&lang=js&"
export * from "./Tabbar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Tabbar.vue?vue&type=style&index=0&id=1d89b952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d89b952",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog});qInstall(component, 'directives', {ClosePopup});
